import React, {Component} from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

class DBOrderItem extends Component {

    render(){
            const { orderItems } = this.props;

            return (   
                <div style={{marginLeft: "32px", marginBottom: "12px"}}>                            
                <ReactTable
                    data={orderItems}
                    pageSize={(orderItems.length > 10) ? 10 : orderItems.length}
                    showPagination={(orderItems.length > 10)}
                    columns={[{
                        Header: 'Name',
                        accessor: 'title' // String-based value accessors!
                        }, {
                        Header: 'Price',
                        accessor: 'price',
                        }, {
                        Header: 'Count',
                        accessor: 'count'
                        }
                    ]}                                        
                />
                </div>                 
        )
    }
}

export default DBOrderItem
